import { IStaffInfo } from '../../MeetOurStaff';

export const gridContainerStyles = {
	transition: 'opacity .3s ease',
	cursor: 'pointer',
	'&:hover': { opacity: '.7' },
};

export const avatarGridItemStyles = {
	mr: '1rem',
};

export const avatarStyles = {
	width: { xs: '4rem', md: '5rem' },
	height: { xs: '4rem', md: '5rem' },
};

export const getStaffInfoGridItemStyles = (showAvatar: IStaffInfo | undefined) => ({
	flex: 1,
	textAlign: { xs: 'left', md: showAvatar ? 'left' : 'center' },
});

export const nameTypographyStyles = {
	marginBottom: { xs: '0', md: '0.25rem' },
	display: 'block',
};

export const jobTitleTypographyStyles = {
	marginBottom: { xs: '0', md: '0.25rem' },
	display: 'block',
	textTransform: 'uppercase',
};

export const educationTypographyStyles = {
	display: 'block',
};

export const TAGDialogStyles = {
	'.MuiGrid-container': {
		width: '100%',
	},
	'.MuiGrid-root': {
		position: 'static',
	},
	'.MuiPaper-root': {
		maxWidth: '620px',
		width: '100%',
	},
};
